var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToolsLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 474,
    height: 475,
    viewBox: "0 0 474 475",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#E9530D",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: "M313.738 313.944l11.265-11.266 28.274-28.281 101.685 101.685c18.717 18.72 18.717 49.07 0 67.79l-5.648 5.648-5.649 5.649c-18.72 18.717-49.07 18.717-67.786 0L274.194 353.484l28.282-28.274 11.262-11.266z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E9530D",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: "M284.963 264.113l39.981 38.865-22.527 22.528-40.825-39.657m-79.77-77.486L74.508 104.122 37.2 100.685 9 38.532l11.262-11.266L31.528 16 93.68 44.204l3.437 37.308L203.54 184.964"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#78B9EB",
    d: "M313.738 313.94l11.265-11.265.004.003-11.266 11.266z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#78B9EB",
    d: "M302.472 325.202l11.266-11.262.003.004-11.261 11.266z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E9530D",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: "M24.653 444.804l-5.63-5.59c-18.696-18.744-18.696-49.085 0-67.829l225.29-225.29c-10.75-40.151 1.65-82.952 32.198-111.136 30.548-28.184 74.207-37.105 113.365-23.16l-60.16 60.238 16.937 50.81 50.81 16.937 60.238-60.16c13.945 39.158 5.024 82.817-23.16 113.365-28.184 30.548-70.985 42.949-111.137 32.198l-225.29 225.29c-18.743 18.696-49.084 18.696-67.828 0l-5.633-5.63v-.043z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolsLine);
export default __webpack_public_path__ + "static/media/tools-line.9eb54fa9fc611818143e1b8f1e5d5bc2.svg";
export { ForwardRef as ReactComponent };